<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [style]="{ width: '480px' }"
  header="Asignar activo real"
>
  <div class="flex flex-column gap-2">
    <label class="font-medium">Activo</label>
    <p-dropdown
      [options]="options"
      [(ngModel)]="selectedAssetId"
      optionLabel="label"
      optionValue="value"
      [filter]="true"
      filterBy="label"
      [showClear]="false"
      [placeholder]="loadingOptions ? 'Cargando activos…' : 'Selecciona un activo disponible'"
      appendTo="body"
      styleClass="w-full"
    >
      <ng-template let-option pTemplate="item">
        <div class="flex justify-content-between align-items-center w-full">
          <span>{{ option.label }}</span>
          <span class="text-500 ml-3">{{ option.amount | currency:'MXN':'symbol':'1.2-2' }}</span>
        </div>
      </ng-template>
    </p-dropdown>
    <p-message
      *ngIf="valueDiffers"
      severity="warn"
      styleClass="w-full"
      text="El valor del activo difiere del provisional cotizado; los montos de la cotización se recalcularán."
    ></p-message>
  </div>
  <ng-template pTemplate="footer">
    <button pButton type="button" label="Cancelar" class="p-button-text" (click)="visible = false" [disabled]="saving"></button>
    <button pButton type="button" label="Asignar" icon="fa-solid fa-check" (click)="confirm()" [disabled]="!selectedAssetId || saving" [loading]="saving"></button>
  </ng-template>
</p-dialog>
